/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Submit_Drawer_DescInputs */

const en_directory_submit_drawer_desc = /** @type {(inputs: Directory_Submit_Drawer_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Everything the review team sees. You can edit this again later in My Tools.`)
};

const zh_directory_submit_drawer_desc = /** @type {(inputs: Directory_Submit_Drawer_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`审核团队将看到这些内容。之后可在 My Tools 中再次编辑。`)
};

/**
* | output |
* | --- |
* | "Everything the review team sees. You can edit this again later in My Tools." |
*
* @param {Directory_Submit_Drawer_DescInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_submit_drawer_desc = /** @type {((inputs?: Directory_Submit_Drawer_DescInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Submit_Drawer_DescInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_submit_drawer_desc(inputs)
	return zh_directory_submit_drawer_desc(inputs)
});
export { directory_submit_drawer_desc as "directory.submit.drawer.desc" }